import Performance from './Performance.container';

export default Performance;
